/* eslint-disable */
import { marketApiUrl, rootUrl } from '../consts/other'
import getCognitoAccessToken from './getCognitoAccessToken'
import track from './track'

export type ApiCallParams<T> = {
  endpoint: string
  method: string
  params: T
  api?: 'market-api' | 'rails-api'
}

const formatParams = (params: any): string => {
  const getPairs = (params: any, keys: string[] = []): [string[], any][] => {
    return Object.entries(params).reduce((pairs: [string[], any][], [key, value]) => {
      if (typeof value === 'object') {
        pairs.push(...getPairs(value, [...keys, key]))
      } else {
        pairs.push([[...keys, key], value])
      }
      return pairs
    }, [] as [string[], any][])
  }

  return (
    '?' +
    getPairs(params)
      .map(([[key0, ...keysRest], value]) => `${key0}${keysRest.map((a) => `[${a}]`).join('')}=${value}`)
      .join('&')
  )
}

const responseError = (response: Response): Promise<never> => {
  return response.text().then((text) => {
    let message = 'Network response was not ok.'
    try {
      const data = JSON.parse(text) as { message?: unknown }
      if (typeof data.message === 'string' && data.message !== '') {
        message = data.message
      }
    } catch {
      message = 'Network response was not ok.'
    }
    throw new Error(message)
  })
}

const apiCall = ({ endpoint, params, method, api = 'rails-api' }: ApiCallParams<any>): Promise<any> => {
  const apiUrl = api === 'market-api' ? marketApiUrl : rootUrl
  let fullUrl = apiUrl + endpoint
  if (method === 'GET' && params) {
    fullUrl += formatParams(params)
  }
  const json = JSON.stringify(params)
  const headers = new Headers()
  headers.append('Content-type', 'application/json')

  return new Promise((resolve, reject) => {
    getCognitoAccessToken()
      .then((token) => {
        if (token) {
          headers.append('Authorization', token)
        }

        fetch(fullUrl, {
          method,
          headers,
          body: method !== 'GET' ? json : undefined
        })
          .then((response) => {
            track('dealer_api_call', { endpoint, method, success: response.ok })
            if (response.ok) {
              return response.json()
            }
            return responseError(response)
          })
          .then((data) => {
            resolve(data)
          })
          .catch((error) => {
            reject(error)
          })
      })
      .catch((error) => {
        fetch(fullUrl, {
          method,
          headers,
          body: method !== 'GET' ? json : undefined
        })
          .then((response) => {
            track('dealer_api_call', { endpoint, method, success: response.ok })
            if (response.ok) {
              return response.json()
            }
            return responseError(response)
          })
          .then((data) => {
            resolve(data)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
  })
}

export default apiCall
